export default __webpack_public_path__ + "static/media/wallet.c746d144.less";